import { faEllipsisV } from '@fortawesome/pro-light-svg-icons/faEllipsisV'

const lightIcons = [
  faEllipsisV
]

export default lightIcons
